import { memo, useEffect } from 'react'
import { FormControl, OutlinedInput, Stack, styled } from '@mui/material'
import { getReferralCodeFromStorage, ReferralQueryKey } from '../../utils'
import { useAtom } from 'jotai'
import { referralCodeAtom } from './atoms'
import toastify from '../../../../components/Toastify'

const ReferralsInputWrap = styled(Stack)`
  gap: 16px;
  margin: 24px 0 0;

  h4 {
    font-size: 14px;
    line-height: 18px;
    font-weight: 600;
    color: rgba(204, 213, 219, 1);
    margin: 0;
  }
`
const ReferralCodeInput = styled('div')``
export const ReferralsInput = memo(() => {
  const [code, setCode] = useAtom(referralCodeAtom)

  useEffect(() => {
    const localCode = getReferralCodeFromStorage()
    if (localCode) {
      setCode(localCode)
    }
  }, [setCode])

  return (
    <ReferralsInputWrap>
      <h4>Referral Link / Code:</h4>
      <ReferralCodeInput>
        <FormControl sx={{ width: '100%' }} variant="outlined">
          <OutlinedInput
            sx={{
              '.MuiOutlinedInput-input': {
                padding: '11.5px 14px',
              },
            }}
            fullWidth
            value={code}
            onFocus={(event) => {
              event.target.select()
            }}
            onInput={(event) => {
              const value = (event.target as HTMLInputElement).value
              if (value.startsWith('http')) {
                const [_, search] = value.split('?')
                if (!search) {
                  toastify.warn('Invalid referral link')
                  return
                }
                const params = new URLSearchParams(search)
                const referralCode = params.get(ReferralQueryKey)

                if (!referralCode) {
                  setCode('')
                  toastify.warn('Invalid referral link')
                } else {
                  setCode(referralCode)
                }
              } else {
                setCode(value)
              }
            }}
          />
        </FormControl>
      </ReferralCodeInput>
    </ReferralsInputWrap>
  )
})
